import { Grid, Tooltip } from '@mui/joy'
import { Box } from '@mui/system'
import { Region } from '~/shared/api/region'
import { driverStatusOptions } from '~/shared/config/constants'
import {
  AsyncAutocompleteInput,
  AutocompleteInput,
  Switch,
  TextInput,
  DateTimePickerInput,
} from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type MainProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export const Main = ({ disabled, skeletonShow }: MainProps) => {
  return (
    <Container data-testid='main-form-container'>
      <ContainerTitle>Превью</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid container xs={12}>
          <Grid xs={5}>
            <TextInput
              label='Название'
              placeholder='Введите название'
              name='name'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={5}>
            <TextInput
              label='Заголовок'
              placeholder='Введите заголовок'
              name='title'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={2}>
            <Tooltip
              variant='outlined'
              title='Запустить ли рассылку в заданое время'
            >
              <Box>
                <Switch
                  label='Активный'
                  name='isActive'
                  skeletonShow={skeletonShow}
                  readOnly={disabled}
                  formControlProps={{ sx: { marginTop: '40px' } }}
                />
              </Box>
            </Tooltip>
          </Grid>
        </Grid>

        <Grid container xs={12}>
          <Grid xs={6}>
            <TextInput
              label='Текст сообщения'
              name='content'
              placeholder='Заполните текст сообщения'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={6}>
            <DateTimePickerInput
              label='Дата и время'
              name='scheduledAt'
              placeholder='Выберите дату и время'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
        </Grid>

        <Grid container xs={12}>
          <Grid xs={6}>
            <AsyncAutocompleteInput
              name='regionsIds'
              label='Регионы'
              fetchOptions={Region.fetchOptions}
              placeholder='Выберите регион'
              readOnly={disabled}
              skeletonShow={skeletonShow}
              multiple
              autocompleteXs={12}
            />
          </Grid>
          <Grid xs={6}>
            <AutocompleteInput
              name='userStatuses'
              label='Статус водителя'
              options={driverStatusOptions}
              multiple
              skeletonShow={skeletonShow}
              readOnly={disabled}
              placeholder='Выберите статус'
              autocompleteXs={12}
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
